var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoQuestions2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5565 25.6433H17.8056C17.396 25.6433 17.1931 25.8557 17.1931 26.2781V26.9861C17.1931 27.4108 17.3984 27.6208 17.8056 27.6208H18.5565C18.967 27.6208 19.169 27.4076 19.169 26.9853V26.2781C19.169 25.8525 18.967 25.6433 18.5565 25.6433ZM18.4873 9.44867C16.8519 9.44867 15.6237 10.0842 15.0088 10.5098C14.6684 10.7222 14.6684 11.0754 14.8736 11.3578L15.078 11.6394C15.2832 11.9925 15.6245 11.9925 15.8957 11.7801C16.373 11.4986 17.3292 11.073 18.3513 11.073C20.2604 11.073 21.5554 12.3457 21.5554 13.9732C21.5554 17.3674 17.26 17.7898 17.26 21.6788V22.2451C17.26 22.6699 17.4644 22.8799 17.8725 22.8799H18.3489C18.6894 22.8799 18.8946 22.6675 18.8946 22.3144V21.6788C18.9638 18.3562 23.2577 17.9306 23.2577 13.76C23.3985 11.2886 21.2842 9.44867 18.4873 9.44867Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "#fff",
    strokeWidth: 1.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoQuestions2);
export default __webpack_public_path__ + "static/media/picto-questions-2.a55711b22ac0835a8e31288306a5bfd2.svg";
export { ForwardRef as ReactComponent };